module.exports = __webpack_public_path__ + "static/media/hedcut-paul.9ac883b9.png";